import Tooltip from '@/common/Tooltip';
import { useMakeModelSearchLink } from '~/hooks/vdp';
import QuestionMarkIcon from '~/icons/QuestionMarkIcon';

type OwnProps = {
  transitCharge: string;
};

export default function ShippingTooltip({ transitCharge }: OwnProps) {
  const searchLink = useMakeModelSearchLink(true);

  return (
    <Tooltip
      content={
        <div className="text-left">
          <p className="mb-16">
            There is a ${transitCharge} shipping cost on this vehicle due to its
            significant transport distance to your location. Shipping fees are
            nonrefundable.
          </p>
          <p>
            Try searching for the same car with{' '}
            <a
              href={searchLink}
              data-analytics-id="Price Details - No Shipping"
              data-qa="no-shipping-link"
            >
              no shipping cost.
            </a>
          </p>
        </div>
      }
      title=""
    >
      <QuestionMarkIcon
        className="ml-4 h-[16px] w-[16px] fill-current text-grey-5"
        data-qa="shipping-fee-question-mark"
      />
    </Tooltip>
  );
}
